import React, { useState, useContext } from "react";
import "swiper/swiper-bundle.css";
import { Button, Col, Image, Row } from "antd";
import iconSteam from "../assets/icons/home/Steam_icon_logo 1.png";
import iconGame from "../assets/icons/home/joystick 1.png";
import iconPriceTag from "../assets/icons/price-tag 1.png";
import iconTrending from "../assets/icons/home/trendingIcon.png";
import iconMostRent from "../assets/icons/home/most_rentIcon.png";
import iconFree from "../assets/icons/home/freeIcon.png";
import iconNew from "../assets/icons/home/newIcon.png";
import SearchIcon from "../assets/icons/searchIcon.png";
import { useAllGameQuery } from "../store/queries/game/game.query.js";
import { handleScrollVertical } from "../utils/scrollHandle.js";
import { LoadingIcon } from "../assets/icons/index.js";
import { debounce } from "lodash";
import { useWishlistMutation } from "../store/mutations/game/wishlist.mutate.js";
import { useNavigate } from "react-router-dom";
import { useGetNetStatus } from "../store/queries/app.queries.js";
import FilterSidebar from "../components/Sidebar/FilterSidebar.js";
import { StateContext } from "../context/reducer.js";
import { contextConstant } from "../context/constant.js";

const Chitiet = () => {
  const { state, dispatch } = useContext(StateContext);
  const { user } = state;
  const [activeFilter, setActiveFilter] = useState("trending");
  const formatCurrency = (amount) => {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const net = localStorage.getItem("net");
  const netData = net ? JSON.parse(net) : null;
  const netId = netData?.id ? netData.id : undefined;

  const { data: netStatus } = useGetNetStatus(netId);

  const isGameFree = netStatus && !!netStatus.isBuy;

  const [searchFilterParams, setSearchFilterParams] = useState({
    search: "",
    sort: "trending",
  });
  const { mutateAsync } = useWishlistMutation();
  
  const handleToggleWishlist = (item) => {
    if (!user) {
      dispatch({
        type: contextConstant.SET_SHOW_LOGIN_MODAL,
        payload: true,
      });
      return;
    }
    mutateAsync({ steamId: item.id, isWishlist: !item.isWishlist });
  };
  const {
    data: allData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useAllGameQuery(8, searchFilterParams);
  const navigate = useNavigate();

  const handleChangeSearchFilter = (filterParams) => {
    setSearchFilterParams((prev) => ({ ...prev, ...filterParams }));
  };

  const handleSearch = debounce((event) => {
    handleChangeSearchFilter({ search: event.target.value });
  }, 1000);

  const handleFilterChange = (sortOption) => {
    setSearchFilterParams((prevParams) => ({
      ...prevParams,
      sort: sortOption,
    }));
  };


  const handleNavigation = (link) => {
    navigate(link);
  };

  const truncateSteamText = (text, wordLimit) => {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return text;
  };

  const filterIcons = {
    trending: iconTrending,
    most_rent: iconMostRent,
    new: iconNew,
    free: iconFree,
  };

  return (
    <div
      className="h-full overflow-y-auto pt-[92px]"
      onScroll={(e) =>
        handleScrollVertical(e, fetchNextPage, hasNextPage, isFetchingNextPage)
      }
    >
      <style
        dangerouslySetInnerHTML={{
          __html: "\n  .shifted {\n  margin-left: auto;\n}\n\n    ",
        }}
      />
      <section className="nft">
        <div className="confirmation-loader-2 overlay-2" />
        <div className="max-w-[1800px] mx-auto sm:px-[50px] md:px-[60px] lg:px-[24px]">
          <div className="flex relative">
            <FilterSidebar
              activeFilter={activeFilter}
              setActiveFilter={setActiveFilter}
              filterIcons={filterIcons}
              handleFilterChange={handleFilterChange}
            />
            <div className="w-full lg:pl-[30px] sm:pl-[0px] position-relative explore-nft ml-auto mt-[42px]">
              <div className="flex justify-between items-center mb-4">
                <div className="flex justify-center">
                  <h2 className="text-white font-normal md:text-xl sm:text-xl xs:text-sm sm:ml-[26px] md:ml-[35px] lg:ml-[20px]">
                    {activeFilter === "trending"
                      ? "Xu hướng"
                      : activeFilter === "most_rent"
                      ? "Mượn nhiều nhất"
                      : activeFilter === "new"
                      ? "Mới ra mắt"
                      : "Game miễn phí"}
                  </h2>
                </div>
                {/* search */}
                <div className="flex justify-between items-center md:w-60 sm:w-[14rem] xs:w-[12rem] lg:w-[16rem] p-2 rounded-lg bg-[#242333] border border-gray-500 text-sm">
                  <input
                    onChange={handleSearch}
                    placeholder="Tìm kiếm"
                    className="bg-transparent h-full w-full"
                  />
                  <img src={SearchIcon} alt="search" className="h-4 w-4" />
                </div>
              </div>

              {/* Game list */}
              {isLoading ? (
                <Col
                  className="flex justify-center items-center h-[50vh]"
                  span={24}
                >
                  <img className="spinner" src={LoadingIcon} alt="Loading..." />
                </Col>
              ) : (
                <Row
                  gutter={[16, 16]}
                  justify="start"
                  className="sm:!ml-[20px] md:!ml-[30px] lg:!ml-[8px]"
                >
                  {allData?.map((item) => (
                    <Col xl={6} lg={8} sm={12} xs={24} key={item.id}>
                      <div className="relative bg-radiant-gradient md:min-h-[300px] lg:h-full w-full rounded-lg">
                        <div className="relative w-full sm:h-36 md:h-36 lg:h-44 overflow-hidden rounded-tl-lg rounded-tr-lg">
                          <div
                            onClick={() => {
                              handleNavigation(`/xemgame/${item.id}`);
                            }}
                            className="w-full h-full cursor-pointer"
                          >
                            <img
                              src={item.images[0]}
                              alt=""
                              className="object-cover w-full h-full transform transition-transform duration-300 hover:scale-110"
                            />
                          </div>
                        </div>
                        <div className="sm:p-2 md:p-4 p-5">
                          <div className="flex flex-wrap justify-between items-start gap-1.25 pb-3 border-b border-white/50">
                            <div className="flex items-center">
                              <div className="sm:sm:h-7 sm:w-7 md:h-8 md:w-8 lg:h-10 lg:w-10 flex items-center">
                                <Image src={iconSteam} alt="" preview={false} />
                              </div>
                              <div className="sm:pl-1 pl-3">
                                <p className="text-white sm:text-xs md:text-sm lg:text-base">
                                  Nền tảng
                                </p>
                                <span className="sm:text-xs md:text-sm lg:text-base">
                                  Steam
                                </span>
                              </div>
                            </div>
                            <div className="flex items-center">
                              <div className="sm:h-7 sm:w-7 md:h-8 md:w-8 lg:h-10 lg:w-10 flex items-center">
                                <Image src={iconGame} alt="" preview={false} />
                              </div>
                              <div className="sm:pl-1 pl-3">
                                <p className="text-white sm:text-xs md:text-sm lg:text-base">
                                  Chế độ
                                </p>
                                <span className="sm:text-xs md:text-sm lg:text-base">
                                  {truncateSteamText(item.chedo, 1)}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="mt-3 flex items-center">
                            <div className="sm:min-h-10 md:min-h-14 min-h-16">
                              <h4 className="truncate-text sm:text-[15px] md:text-xl lg:text-2xl">
                                <div
                                  onClick={() =>
                                    handleNavigation(`/xemgame/${item.id}`)
                                  }
                                  className="cursor-pointer hover:text-blue-400 line-clamp-2"
                                >
                                  {item.tengame}
                                </div>
                              </h4>
                            </div>
                          </div>
                          <div className="flex items-center justify-between">
                            <div></div>
                            <div>
                              <Button
                                onClick={() => handleToggleWishlist(item)}
                                size="small"
                                className={`group rounded-3xl text-base ${
                                  item.isWishlist
                                    ? "text-red-500 bg-blue-950"
                                    : "bg-blue-950 text-white"
                                }`}
                                data-id={item.id}
                                icon={<i className="fas fa-heart" />}
                              >
                                <span className="text-white group-hover:text-blue-500 wishlistCount sm:text-sm md:text-md lg:text-lg">
                                  {item.numberWishlist ?? 0}
                                </span>
                              </Button>
                            </div>
                          </div>
                          <div className="flex justify-between items-center pt-2">
                            <div className="flex items-center">
                              <div className="sm:h-6 sm:w-6 md:h-8 md:w-8 lg:h-10 lg:w-10 flex items-center">
                                <Image
                                  src={iconPriceTag}
                                  alt=""
                                  preview={false}
                                />
                              </div>
                              <span className="text-base text-white font-semibold sm:text-sm md:text-md lg:text-lg">
                                Giá mượn
                              </span>
                            </div>
                            <div className="">
                              <span className="text-base font-semibold text-[#7ED0FF] sm:text-sm md:text-md lg:text-lg">
                                {isGameFree ? 0 : formatCurrency(item.giathue)}
                                đ/giờ
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  ))}
                  {hasNextPage && (
                    <Col className="!mt-9 !mb-14" span={24}>
                      <img
                        className="spinner mx-auto"
                        src={LoadingIcon}
                        alt="spin icon"
                      />
                    </Col>
                  )}
                </Row>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Chitiet;
